/**
 * Created by User on 19/9/2559.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from './auth-guard.service';
import {ActivateComponent} from './account/activate/activate.component';
import {LoginComponent} from './account/login/login.component';
import {OAuthComponent} from './account/oauth/oauth.component';
import {SignUpComponent} from './account/sign-up/sign-up.component';
import {ResetPasswordComponent} from './account/reset-password/reset-password.component';
import {WaitingPageComponent} from './account/thankyou/thankyou.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {PrivacyComponent} from './shared/privacy/privacy.component';
import {TermOfUseComponent} from './shared/terms/terms.component';
import {FormsComponent} from './e-form/forms/forms.component';
import {FormComponent} from './e-form/form/form.component';
import { PdpaComponent } from './shared/pdpa/pdpa.component';
import {EditSecurityComponent} from './account/profile/security/edit-security.component';

const routes: Routes = [
   {
      path: 'signup',
      component: SignUpComponent
   },
   {
      path: 'activate/:device',
      component: ActivateComponent
   },
   {
      path: 'activate',
      component: ActivateComponent
   },
   {
      path: 'login',
      children: [
         {
            path: '',
            component: LoginComponent
         },
         {
            path: '**',
            component: LoginComponent
         }
      ]
   },
   {
      path: 'auth/:provider',
      component: OAuthComponent
   },
   {
      path: 'reset/:device',
      component: ResetPasswordComponent
   },
   {
      path: 'waiting/:email',
      component: WaitingPageComponent
   },
   {
      path: 'privacy',
      component: PrivacyComponent
   },
   {
      path: 'pdpa',
      component: PdpaComponent
   },
   {
      path: 'terms',
      component: TermOfUseComponent
   },
   {
      path: 'forms',
      component: FormsComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'form',
      component: FormComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'dashboard',
      component: DashboardComponent,
      canActivate: [AuthGuard]
   },
   {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full'
   },
   {
      path: '**',
      redirectTo: 'dashboard',
      pathMatch: 'full'
   },
   {
      path: 'editsecurity',
      component: EditSecurityComponent,
      canActivate: [AuthGuard]
   },
   // {
   //    path: '**',
   //    component: DashboardComponent,
   //    canActivate: [AuthGuard]
   // }
];

@NgModule({
   imports: [RouterModule.forRoot(routes)],
   exports: [RouterModule]
})
export class AppRoutingModule {
}
